import axios from "axios";
import { ROOT_SERVER } from "../utilities/Static";
export default async function LoginFunction(email) {
  const { data: response } = await axios.post(`${ROOT_SERVER}login`, {
    email: email,
  });
  return response;
}
